import {TrackingCustomerData} from '@aboutyou/legacy-tracking-sdk';
import {EmailSubscriptionType} from '../../grpc_client/grips/protos/email_subscriptions/v1/email_subscription';
import {GetDropPageResponse} from '../../grpc_client/grips/protos/pages/v1/pages_service';
import {Drop_USP} from '../../grpc_client/grips/protos/shared/drop';

export interface DropsOverview {
  dropsOverviewPage: GetDropPageResponse;
  trackingCustomer?: TrackingCustomerData | null;
}

export interface DropsBannerProps {
  imageHash: string | undefined;
  usps: Drop_USP[] | undefined;
  title: Drop_USP | undefined;
}

export enum DropCasesEnum {
  ACTIVE_DROPS = 'activeDrops',
  PAST_DROPS = 'pastDrops',
  UPCOMING_DROPS = 'upcomingDrops',
  LAST_CHANCE_DROP = 'lastChanceDrop',
}

export interface IsSubscribedEmailType {
  email: string;
  allDrops?: {
    isSubscribed?: boolean;
    subscribedTypes?: EmailSubscriptionType[];
  };
  individualDrops: {[key in number]: boolean};
  customEmails?: {[key in string]: (number | 'all')[]};
}

export interface DropsSubscriptionSchema {
  guest?: IsSubscribedEmailType;
  ayUser?: IsSubscribedEmailType;
}

export type IndividualDropByEmail = Record<string, {[key in number]: boolean}>;

export type DropsSubscriptions = DropsSubscriptionSchema & {
  modalData: DropSubscribeModalData;
} & {
  setSubscriptions: (subscriptions: DropsSubscriptionSchema) => void;
  setModalData: (modalData: DropSubscribeModalData) => void;
  updateIndividualDrops?: (individualDrops: IndividualDropByEmail) => void;
};

export interface DropSubscribeModalData {
  backgroundImageUrl?: string;
  headline?: string;
  subline?: string;
  isOpen?: boolean;
  allDropsSubscriptionStatus?: boolean;
  currentDrop?: boolean;
  dropId?: number;
}
